import React from 'react';
import { UrlService } from "../../../../core/services/UrlService"
import './hero.scss';
import $ from "jquery";

const Hero: React.FC<any> = ({ bgImage = 'self-test/adpkd/background.png' }) => {
    const moveToSelfTest = () => {
        $("html, body").animate({ scrollTop: $('.self-test__test').position()?.top - 50 || 0 }, 1000);
    };

    const moveToContent = () => {
        $("html, body").animate({ scrollTop: $('.self-test__content-sections').position()?.top - 50 || 0 }, 1000);
    };

    return (
        <section role="img" aria-label="Image Description">
            <div className="self-test__hero" style={UrlService.getLocalImageUrlStyle(bgImage)}>
                <div className="container">
                    <div className="self-test__hero-title-container">
                        <div className="self-test__hero-title">
                            <h1 className="entry-title mb-4"> 您有<span className="important">多囊腎病</span>嗎？</h1>
                        </div>
                    </div>

                    <div className="self-test__hero-content-container">
                        <div className="self-test__hero-content-text">
                            <p>
                                您有聽過多囊腎病嗎？它看似十分罕見，卻是最常見的遺傳性腎病 － 常染色體顯性多囊性腎臟病(ADPKD) 
                                正影響全球超過1200萬人，每400至2500人中就有1人患病。以香港750萬人口計算，
                                即有近3000至18750位ADPKD 患者<sup>1</sup>。這種慢性疾病會隨年齡惡化，影響腎功能。
                                病情更有機會惡化至慢性腎病末期（第5期），即末期腎衰竭<sup>1</sup>。
                                多囊性腎臟病更有機會引起併發症，影響其他器官，引致中風、心臟問題等，嚴重性不容忽視<sup>2</sup>。
                            </p>
                            <p>
                                雖然ADPKD暫時無法根治，但如能及早發現，便能通過藥物等方法，減緩病情惡化<sup>2</sup>。
                                立即開始評估，了解您是否出現ADPKD的症狀。
                            </p>
                            <div className="self-test__hero-button-container">
                                <button className="self-test__button primary" onClick={moveToSelfTest}>
                                    開始評估
                                </button>
                                <button className="self-test__button secondary" onClick={moveToContent}>
                                    了解 ADPKD
                                </button>
                            </div>
                        </div>
                        <div>
                            <img src={UrlService.getLocalImageUrl('self-test/adpkd/hero-icon.png?2')} />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Hero;